module.exports = __webpack_public_path__ + "9e784fb2b93b65290a068e9880fc966d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/white-logo.png
// module id = 570
// module chunks = 0